/**
 * @generated SignedSource<<a8c1136ff28a5e703f74e4028d6038da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettingsQuery$variables = {
  ujId: number;
};
export type selfServiceSettingsQuery$data = {
  readonly userJourney: {
    readonly isSelfService: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment" | "selfServiceSettings_statusFragment">;
  };
};
export type selfServiceSettingsQuery = {
  response: selfServiceSettingsQuery$data;
  variables: selfServiceSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ujId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ujId",
    "variableName": "ujId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSelfService",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceSettings_mainSettingsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceSettings_statusFragment"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selfServiceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutOffOK",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alertOnSlow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8642a19a2565e7e0e2798615189af24d",
    "id": null,
    "metadata": {},
    "name": "selfServiceSettingsQuery",
    "operationKind": "query",
    "text": "query selfServiceSettingsQuery(\n  $ujId: Int!\n) {\n  userJourney(ujId: $ujId) {\n    ...selfServiceSettings_mainSettingsFragment\n    ...selfServiceSettings_statusFragment\n    isSelfService\n    id\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n}\n\nfragment selfServiceSettings_statusFragment on UserJourney {\n  id\n  status\n}\n"
  }
};
})();

(node as any).hash = "081050db8c54e57b4a398068d40f6a3d";

export default node;
